import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarCollapsed: false,
  darkMode: false,
  theme: 'light',
  fontSize: 'medium',
  notifications: [],
  toasts: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
      state.theme = action.payload ? 'dark' : 'light';
    },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      state.theme = state.darkMode ? 'dark' : 'light';
    },
    setFontSize: (state, action) => {
      state.fontSize = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      state.darkMode = action.payload === 'dark';
    },
    addNotification: (state, action) => {
      state.notifications.unshift({
        id: Date.now().toString(),
        read: false,
        timestamp: new Date().toISOString(),
        ...action.payload,
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter((n) => n.id !== action.payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    addToast: (state, action) => {
      state.toasts.push({
        id: Date.now().toString(),
        ...action.payload,
      });
    },
    removeToast: (state, action) => {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    clearToasts: (state) => {
      state.toasts = [];
    },
  },
});

export const {
  toggleSidebar,
  setDarkMode,
  toggleDarkMode,
  setFontSize,
  setTheme,
  addNotification,
  removeNotification,
  clearNotifications,
  addToast,
  removeToast,
  clearToasts,
} = uiSlice.actions;
export default uiSlice.reducer;
